// extracted by mini-css-extract-plugin
export default {"root":"Welcome__root--YnhK1G","center":"Welcome__center--o34bSF"};